<template>
  <header class="header">
    <inline-svg src="/images/logo.svg" :class="'header__logo'" />
  </header>
  <main id="scrollToTop">
    <slot />
  </main>
</template>

<script>
  import { onMounted } from "@vue/runtime-core";

  export default {
    setup: () => {
      // mounted
      onMounted(() => {
        console.debug("Component is mounted!");
      });
    },
  };
</script>
